const messages = {
  pt: {
    translations: {
      titleSystem: {
        title: "Nota Certa",
        subTitle: "NFCe",
      },
      languages: {
        language1: "Português",
        language2: "English",
        language3: "Español",
      },
      page404: {
        message:
          "Parece que você se perdeu, clique em uma das opções do lado esquerdo para voltar à página!",
      },
      drawerMenu: {
        title: "Nota Certa",
        items: {
          mainItems: {
            registrations: "Cadastros",
            invoices: "Vendas",
            settings: "Configurações",
            logout: "Sair",
          },
          subItems: {
            companies: "Empresas",
            users: "Usuários",
            products: "Produtos",
          },
        },
      },
      search: {
        search: "Pesquisar",
      },
      genericPage: {
        headerTitle: "Cabeçalho do Título",
        titleButton: "Botão do Título",
      },
      verification: {
        message: "Verifique também a caixa de spam e lixo eletrônico.",
        title: "Verifique seu email",
      },
      login: {
        message: "Seja bem-vindo ao Nota Certa, por favor, informe seus dados para continuar.",
        form: {
          name: "Nome completo",
          fone: "Celular",
          email: "E-mail",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          continue: "Continuar",
        },
      },
      button: {
        add: "Adicionar",
        exit: "Sair",
        edit: "Editar",
        delete: "Excluir",
        save: "Salvar",
        cancel: "Cancelar",
        enter: "Entrar",
        close: "Fechar",
        replace: "Substituir",
      },
      toasts: {
        deleted: "Excluído com sucesso!",
        saved: "Gravado com sucesso!",
        embalagemError: "Preencher todos os campos!",
      },
      validation: {
        error: {},
        warning: {
          tooLong: "Muito longo!",
          tooShort: "Muito curto!",
          required: "Obrigatório",
          emailInvalid: "E-mail inválido",
        },
      },
      empresa: {
        title: "Empresa",
        pluralTitle: "Empresas",

        fields: {
          razaoSocial: "Razão Social",
          nomeFantasia: "Nome fantasia",
          cnpj: "CNPJ",
          inscricaoEstadual: "Inscrição Estadual",

          endereco: {
            title: "Endereço",
            cep: "CEP",
            logradouro: "Endereço",
            numero: "Número",
            complemento: "Complemento",
            bairro: "Bairro",
            municipio: "Município",
            uf: "UF",
            pais: "País",
          },
          tributacao: {
            title: "Regime tributário",
            apuracaoImposto: "Tipo apuração", 
            cnaePrincipal: "CNAE",
          },
        },
      },
      produto: {
        title: "Produto",
        pluralTitle: "Produtos",
        fields: {
          nome: "Nome",
          statusAtivo: "Ativo",
          statusInativo: "Inativo",
          embalagem: "Embalagem",
          preco: "Preço",
        },
      },

      vendas: {
        title: "Vendas",
        table: {
          status: "Status",
          emissao: "Emissão",
          numero: "Número",
          numeroSmartphone: "N.",
          valor: "Valor",
          chave: "Chave",
          acoesLista: {
            visualizar: "Visualizar",
            visualizarErro: "Visualizar Erro",
            download: "Download",
            compartilhar: "Compartilhar",
            cancelarNota: "Cancelar Nota",
            corrigirReenviar: "Corrigir / Reenviar",
            inutilizar: "Inutilizar",
          }
        }
      },

      empresaConfig: {
        csc: {
          title: "Gerenciamento CSC",
          csc: "ID Código",
          codigoCsc: "Cód Segurança",
          ambiente: "Ambiente",
        },
        nfce:{
          title: "NFC-e",
          serie: "Série",
          ultimoNumero: "Número NFC-e",
          informarCpf: "Informar CPF",
        },
        certificado: {
          title: "Certificado",
          hashSenha: "Senha",
          certificado: "Certificado",
          dataValidade: "Validade",
        },
        tributacaoPadrao: {
          title: "Tributação",
          operacao: "Operação",
          cstCsosnIcms: " CSOSN",
          cstPisCofins: "Pis Cofins",
          ncm: "NCM",
          cest: "CEST",
          padrao: "Usa tributação padrão",
        },
      },

      emissao: {
        title: "NFC-e",
      },

      user: {
        title: "Usuário", 
        pluralTitle: "Usuários",
        field: {
          name: "Nome",
          password: "Senha",
          email: "E-mail",
          profile: "Perfil",
          admin: "Administrador",
          user: "Usuário",
        },
      },
    },
  },
};

export { messages };
